import type { DocumentLinkTargetKind } from "@/engine/types";
import { useProjectStore } from "@/store/project-store";

/** 문서 위에 대상 상세를 연다. 일정은 간트로 보내지 않는다. 없는 대상은 열지 않는다. */
export function openDocumentTarget(kind: DocumentLinkTargetKind, id: string) {
  const store = useProjectStore.getState();
  if (kind === "executionTask") {
    if (!store.project.executionTasks.some((task) => task.id === id)) return;
    store.setExecutionFocus(id);
    return;
  }
  if (kind === "record") {
    if (!store.project.records.some((record) => record.id === id)) return;
    store.setRecordFocus(id);
    return;
  }
  store.setSchedulePeek(id);
}

export function openMentionTarget(kind: string, id: string) {
  if (kind !== "executionTask" && kind !== "scheduleTask" && kind !== "record") return;
  if (!id) return;
  openDocumentTarget(kind, id);
}
